module.exports = __webpack_public_path__ + "img/shot_tx2.f64866c8.jpg";